// ============================================================
// FloraIQ - Relatorios: vocabulario (modelos e catalogo previstos)
// ============================================================
// Movido de src/mocks/relatorios.ts. Descreve QUE relatorios o produto
// preve, nao relatorios gerados: nao ha backend de geracao ainda, entao
// nenhuma data, contagem, responsavel ou status de geracao fica aqui.

export interface ReportTemplateDef {
  id: string;
  name: string;
  purpose: string;
  audience: string;
  sections: string[];
  formats: string[];
  icon: string;
}

export interface ReportCatalogItem {
  id: string;
  title: string;
  description: string;
  indicators: string[];
  type: string;
}


/** Icone por tipo de relatorio (era duplicado em cada painel tematico). */
export const reportTypeIcons: Record<string, string> = {
  "Inventário arbóreo": "ri-tree-line",
  "Técnico": "ri-file-list-3-line",
  "FCA individual": "ri-file-text-line",
  "Espécies": "ri-leaf-line",
  "Árvores de risco": "ri-alert-line",
  "Manejo recomendado": "ri-scissors-line",
  "Auditoria": "ri-search-line",
  "Área verde": "ri-landscape-line",
  "Unidade de Conservação": "ri-shield-star-line",
  "Compensação ambiental": "ri-plant-line",
  "Documental": "ri-folder-line",
  "Executivo": "ri-government-line",
  "Carbono": "ri-cloud-line",
  "RRR / Governança": "ri-shield-check-line",
};

export const reportTemplates: ReportTemplateDef[] = [
  {
    id: "tpl-001",
    name: "Modelo Técnico Completo CTA",
    purpose: "Relatório técnico completo de inventário arbóreo com todos os indicadores, tabelas, gráficos, mapas e recomendações.",
    audience: "Responsáveis técnicos e consultorias ambientais",
    sections: ["Capa", "Sumário executivo", "Metodologia", "Indicadores gerais", "Tabelas técnicas", "Gráficos", "Mapas", "Fotos", "FCA resumidas", "Parecer técnico", "Recomendações", "Anexos", "Assinatura técnica"],
    formats: ["PDF", "XLSX", "DOCX"],
    icon: "ri-file-list-3-line",
  },
  {
    id: "tpl-002",
    name: "Modelo Executivo para Prefeitura",
    purpose: "Sumário executivo com indicadores-chave e recomendações para tomada de decisão pela gestão pública municipal.",
    audience: "Prefeitos, secretários e gestores públicos",
    sections: ["Capa", "Sumário executivo", "Indicadores gerais", "Gráficos", "Recomendações", "Assinatura técnica", "QR Code de validação"],
    formats: ["PDF"],
    icon: "ri-government-line",
  },
  {
    id: "tpl-003",
    name: "Modelo Fotográfico",
    purpose: "Relatório fotográfico com imagens georreferenciadas, legendas técnicas e anotações por indivíduo arbóreo.",
    audience: "Equipes de campo e fiscalização ambiental",
    sections: ["Capa", "Metodologia", "Fotos", "Coordenadas", "Anotações técnicas"],
    formats: ["PDF"],
    icon: "ri-camera-line",
  },
  {
    id: "tpl-004",
    name: "Modelo de Árvores de Risco",
    purpose: "Relatório focado em árvores com classificação de risco, com priorização e recomendações de manejo emergencial.",
    audience: "Defesa Civil e gestores de risco",
    sections: ["Capa", "Metodologia de classificação", "Lista de árvores críticas", "Mapas", "Recomendações emergenciais", "Prazos", "Assinatura técnica"],
    formats: ["PDF", "XLSX"],
    icon: "ri-alert-line",
  },
  {
    id: "tpl-005",
    name: "Modelo de Manejo",
    purpose: "Relatório com recomendações detalhadas de manejo arbóreo: poda, tratamento, remoção e replantio.",
    audience: "Empresas executoras e secretarias de obras",
    sections: ["Capa", "Resumo de recomendações", "Detalhamento por árvore", "Mapas", "Cronograma sugerido", "Orçamento estimado"],
    formats: ["PDF", "XLSX"],
    icon: "ri-scissors-line",
  },
  {
    id: "tpl-006",
    name: "Modelo de Compensação",
    purpose: "Relatório de monitoramento de compensações ambientais com indicadores de plantio, sobrevivência e vistorias.",
    audience: "Órgãos ambientais e empreendedores",
    sections: ["Capa", "Obrigação ambiental", "Indicadores de plantio", "Taxa de sobrevivência", "Vistorias", "Fotos", "CO2e preliminar", "Status"],
    formats: ["PDF", "XLSX"],
    icon: "ri-plant-line",
  },
  {
    id: "tpl-007",
    name: "Modelo de UC",
    purpose: "Relatório de gestão de Unidade de Conservação com inventário, plano de manejo e monitoramento.",
    audience: "Gestores de UC e órgãos ambientais",
    sections: ["Capa", "Caracterização da UC", "Inventário arbóreo", "Espécies ameaçadas", "Pressões e ameaças", "Plano de manejo", "Recomendações"],
    formats: ["PDF", "DOCX"],
    icon: "ri-landscape-line",
  },
  {
    id: "tpl-008",
    name: "Modelo de Carbono",
    purpose: "Relatório de estimativas de carbono urbano com metodologia, indicadores e análise por projeto e tipo de área.",
    audience: "Gestores ESG e consultorias de sustentabilidade",
    sections: ["Capa", "Aviso de estimativas preliminares", "Metodologia", "Indicadores gerais", "CO2e por projeto", "CO2e por tipo de área", "Qualidade dos dados", "Limitações"],
    formats: ["PDF", "XLSX"],
    icon: "ri-cloud-line",
  },
  {
    id: "tpl-009",
    name: "Modelo Documental",
    purpose: "Índice documental completo de projeto com fontes, autorizações, laudos e metadados.",
    audience: "Gestores de projeto e auditoria",
    sections: ["Capa", "Índice documental", "Resumo por tipo", "Documentos vencidos", "Autorizações", "Laudos técnicos", "Qualidade documental"],
    formats: ["PDF", "XLSX"],
    icon: "ri-folder-line",
  },
  {
    id: "tpl-010",
    name: "Modelo RRR",
    purpose: "Relatório de responsabilidades, restrições e autorizações conforme modelo LADM-FloraIQ.",
    audience: "Jurídico, procuradorias e órgãos de controle",
    sections: ["Capa", "Partes envolvidas", "Papéis e vínculos", "Responsabilidades ativas", "Restrições ambientais", "Autorizações", "Obrigações pendentes", "Fontes documentais"],
    formats: ["PDF", "DOCX"],
    icon: "ri-shield-check-line",
  },
  {
    id: "tpl-011",
    name: "Modelo de Transparência Pública",
    purpose: "Relatório de transparência para divulgação pública no portal da prefeitura com indicadores do patrimônio arbóreo.",
    audience: "Cidadãos e órgãos de controle social",
    sections: ["Capa", "Indicadores gerais", "Distribuição por bairro", "Espécies mais frequentes", "Áreas verdes", "Ações realizadas", "Planejamento futuro"],
    formats: ["PDF"],
    icon: "ri-eye-line",
  },
  {
    id: "tpl-012",
    name: "Modelo FCA Individual",
    purpose: "Ficha Cadastral Arbórea individual com todos os dados dendrométricos, fotos, vistorias e histórico.",
    audience: "Responsáveis técnicos e fiscalização",
    sections: ["Capa", "Dados de localização", "Dados dendrométricos", "Estado fitossanitário", "Classificação de risco", "Interferências", "Fotos", "Vistorias", "QR Code de validação"],
    formats: ["PDF"],
    icon: "ri-file-text-line",
  },
];

// ============================================================
// CTA Reports
// ============================================================
export const ctaReports: ReportCatalogItem[] = [
  {
    id: "cta-001",
    title: "Inventário Arbóreo Completo",
    description: "Relatório técnico completo com todos os indivíduos arbóreos cadastrados no CTA, dados dendrométricos e indicadores.",
    indicators: ["Total de árvores", "Espécies", "Distribuição espacial", "Fitossanidade", "Risco"],
    type: "Inventário arbóreo",
  },
  {
    id: "cta-002",
    title: "Lista de Árvores Cadastradas",
    description: "Listagem completa em formato tabular com código CTA, espécie, localização e dados principais de cada indivíduo.",
    indicators: ["Código CTA", "Espécie", "Bairro", "Status de revisão"],
    type: "Técnico",
  },
  {
    id: "cta-003",
    title: "FCA Individual",
    description: "Ficha Cadastral Arbórea individual com todos os dados, fotos, vistorias e QR Code de validação.",
    indicators: ["Dados completos", "Fotos", "Vistorias", "QR Code"],
    type: "FCA individual",
  },
  {
    id: "cta-004",
    title: "FCA em Lote",
    description: "Geração de múltiplas FCAs em lote com opção de selecionar por projeto, bairro ou lista de códigos CTA.",
    indicators: ["Quantidade de FCAs", "Projeto", "Bairro"],
    type: "FCA individual",
  },
  {
    id: "cta-005",
    title: "Espécies Mais Frequentes",
    description: "Ranking das espécies mais frequentes no inventário, com distribuição por família botânica e origem (nativa/exótica).",
    indicators: ["Top 10 espécies", "Famílias", "Nativas vs exóticas"],
    type: "Espécies",
  },
  {
    id: "cta-006",
    title: "Estado Fitossanitário",
    description: "Distribuição do estado fitossanitário das árvores: bom, regular, ruim e morta, com análise por bairro e espécie.",
    indicators: ["Distribuição por estado", "Árvores em estado crítico", "Recomendações"],
    type: "Técnico",
  },
  {
    id: "cta-007",
    title: "Classe de Risco",
    description: "Classificação de risco arbóreo com distribuição por classe e localização geográfica das árvores críticas.",
    indicators: ["Distribuição por classe", "Árvores críticas", "Mapa de risco"],
    type: "Árvores de risco",
  },
  {
    id: "cta-008",
    title: "Manejo Recomendado",
    description: "Relatório consolidado de recomendações de manejo com quantitativos por tipo de intervenção sugerida.",
    indicators: ["Podas", "Tratamentos", "Remoções", "Replantios"],
    type: "Manejo recomendado",
  },
  {
    id: "cta-009",
    title: "Árvores Sem Foto",
    description: "Lista de árvores cadastradas que ainda não possuem registro fotográfico vinculado.",
    indicators: ["Quantidade sem foto", "Por projeto", "Por bairro"],
    type: "Auditoria",
  },
  {
    id: "cta-010",
    title: "Árvores Sem Espécie Identificada",
    description: "Levantamento de árvores com espécie não identificada ou pendente de confirmação botânica.",
    indicators: ["Quantidade", "Por projeto", "Prioridade de identificação"],
    type: "Auditoria",
  },
  {
    id: "cta-011",
    title: "Árvores Pendentes de Revisão",
    description: "Lista de árvores que necessitam de revisão cadastral, com justificativa e prazo recomendado.",
    indicators: ["Pendentes", "Por projeto", "Vencidas"],
    type: "Auditoria",
  },
];

// ============================================================
// Environmental Reports
// ============================================================
export const environmentalReports: ReportCatalogItem[] = [
  {
    id: "env-001",
    title: "Áreas Verdes Cadastradas",
    description: "Relatório completo das áreas verdes municipais com indicadores por tipo, área total e estado de conservação.",
    indicators: ["Total de áreas", "Área total (ha)", "Distribuição por tipo"],
    type: "Área verde",
  },
  {
    id: "env-002",
    title: "Unidades de Conservação",
    description: "Relatório de gestão das UCs municipais com inventário, plano de manejo e monitoramento ambiental.",
    indicators: ["Total de UCs", "Área protegida (ha)", "Status do plano de manejo"],
    type: "Unidade de Conservação",
  },
  {
    id: "env-003",
    title: "APPs Urbanas",
    description: "Diagnóstico das Áreas de Preservação Permanente urbanas com estado de conservação e pressões antrópicas.",
    indicators: ["Total de APPs", "Extensão (km)", "Estado de conservação"],
    type: "Área verde",
  },
  {
    id: "env-004",
    title: "Áreas de Recuperação",
    description: "Monitoramento de áreas em processo de recuperação ambiental com indicadores de evolução.",
    indicators: ["Áreas em recuperação", "Área total (ha)", "Estágio da recuperação"],
    type: "Compensação ambiental",
  },
  {
    id: "env-005",
    title: "Árvores em Áreas Ambientais",
    description: "Inventário arbóreo das árvores localizadas dentro de áreas verdes, UCs e APPs.",
    indicators: ["Total de árvores", "Por tipo de área", "Fitossanidade"],
    type: "Inventário arbóreo",
  },
  {
    id: "env-006",
    title: "Risco Crítico em Áreas Verdes",
    description: "Identificação de árvores com risco crítico dentro de áreas verdes públicas, com mapas e recomendações.",
    indicators: ["Árvores críticas", "Por área verde", "Prioridade de intervenção"],
    type: "Árvores de risco",
  },
  {
    id: "env-007",
    title: "Documentos Vinculados a Áreas Ambientais",
    description: "Levantamento de documentos, autorizações e laudos vinculados a áreas verdes, UCs e APPs.",
    indicators: ["Total de documentos", "Por tipo de área", "Documentos vencidos"],
    type: "Documental",
  },
  {
    id: "env-008",
    title: "Relatório Ambiental Executivo",
    description: "Sumário executivo das áreas ambientais municipais para gestores, com indicadores e recomendações.",
    indicators: ["Indicadores consolidados", "Áreas prioritárias", "Recomendações"],
    type: "Executivo",
  },
];

// ============================================================
// Carbon Reports
// ============================================================
export const carbonReports: ReportCatalogItem[] = [
  {
    id: "car-001",
    title: "Relatório Preliminar de Carbono Urbano",
    description: "Estimativas preliminares de biomassa, carbono estocado e CO2e do patrimônio arbóreo urbano.",
    indicators: ["CO2e total", "Carbono (t C)", "Biomassa (t)", "Árvores consideradas"],
    type: "Carbono",
  },
  {
    id: "car-002",
    title: "Biomassa Estimada por Projeto",
    description: "Distribuição da biomassa estimada por projeto de inventário, com metodologia e nível de confiança.",
    indicators: ["Biomassa por projeto", "Metodologia", "Confiança"],
    type: "Carbono",
  },
  {
    id: "car-003",
    title: "CO2e por Projeto",
    description: "Estimativas de CO2 equivalente por projeto, com análise comparativa e evolução temporal.",
    indicators: ["CO2e por projeto", "Comparativo", "Evolução"],
    type: "Carbono",
  },
  {
    id: "car-004",
    title: "CO2e por Área Verde e UC",
    description: "Distribuição das estimativas de CO2e entre áreas verdes e Unidades de Conservação.",
    indicators: ["CO2e por área verde", "CO2e por UC", "Ranking"],
    type: "Carbono",
  },
  {
    id: "car-005",
    title: "Compensações Ambientais",
    description: "Monitoramento de compensações ambientais com indicadores de carbono e sobrevivência de mudas.",
    indicators: ["Compensações ativas", "Mudas plantadas", "CO2e preliminar"],
    type: "Compensação ambiental",
  },
  {
    id: "car-006",
    title: "Qualidade dos Dados de Carbono",
    description: "Painel de qualidade dos dados utilizados nas estimativas de carbono, com métricas de completude.",
    indicators: ["% DAP preenchido", "% altura preenchida", "% espécie identificada", "Confiança"],
    type: "Auditoria",
  },
  {
    id: "car-007",
    title: "Relatório ESG Ambiental",
    description: "Relatório corporativo de indicadores ambientais para ESG, com dados de carbono e sustentabilidade.",
    indicators: ["Indicadores ESG", "Carbono", "Compensações", "Sustentabilidade"],
    type: "Carbono",
  },
];

// ============================================================
// Documentary / RRR Reports
// ============================================================
export const documentaryReports: ReportCatalogItem[] = [
  {
    id: "doc-001",
    title: "Índice Documental do Projeto",
    description: "Índice completo de documentos vinculados ao projeto, com classificação por tipo e status.",
    indicators: ["Total de documentos", "Por tipo", "Status"],
    type: "Documental",
  },
  {
    id: "doc-002",
    title: "Documentos Vencidos",
    description: "Levantamento de documentos vencidos ou próximos do vencimento, com alertas e ações recomendadas.",
    indicators: ["Vencidos", "A vencer 30 dias", "A vencer 60 dias"],
    type: "Documental",
  },
  {
    id: "doc-003",
    title: "Autorizações Ambientais",
    description: "Compilado de autorizações ambientais emitidas com status de vigência e execução.",
    indicators: ["Autorizações ativas", "Vencidas", "Pendentes de execução"],
    type: "Documental",
  },
  {
    id: "doc-004",
    title: "Laudos Técnicos",
    description: "Relatório de laudos fitossanitários, pareceres de risco e laudos técnicos emitidos no período.",
    indicators: ["Total de laudos", "Por tipo", "Responsáveis técnicos"],
    type: "Documental",
  },
  {
    id: "doc-005",
    title: "Fontes por Árvore CTA",
    description: "Mapeamento de fontes documentais vinculadas a cada indivíduo arbóreo do CTA.",
    indicators: ["Árvores com fonte", "Sem documento", "Tipos de fonte"],
    type: "Documental",
  },
  {
    id: "doc-006",
    title: "Responsabilidades Ativas",
    description: "Relatório de responsabilidades ambientais ativas conforme modelo LADM-FloraIQ.",
    indicators: ["Partes responsáveis", "Obrigações ativas", "Status"],
    type: "RRR / Governança",
  },
  {
    id: "doc-007",
    title: "Restrições Ambientais",
    description: "Mapeamento de restrições ambientais vigentes vinculadas a unidades ambientais.",
    indicators: ["Restrições ativas", "Por tipo", "Unidades afetadas"],
    type: "RRR / Governança",
  },
  {
    id: "doc-008",
    title: "Obrigações Pendentes",
    description: "Levantamento de obrigações ambientais pendentes de cumprimento com prazos e responsáveis.",
    indicators: ["Obrigações pendentes", "Vencidas", "Em andamento"],
    type: "RRR / Governança",
  },
  {
    id: "doc-009",
    title: "Compensações Monitoradas",
    description: "Monitoramento de compensações ambientais com indicadores de plantio e vistorias.",
    indicators: ["Compensações ativas", "Mudas", "Sobrevivência"],
    type: "Compensação ambiental",
  },
  {
    id: "doc-010",
    title: "Governança LADM-FloraIQ",
    description: "Relatório integrado de governança conforme modelo LADM, vinculando partes, fontes, unidades e RRR.",
    indicators: ["Partes", "Fontes", "Unidades", "RRR"],
    type: "RRR / Governança",
  },
];
